import { actions as tenantActions } from 'core/logic/tenant/tenant.reducer'
import { call, put } from 'redux-saga/effects'
import * as tenantService from './tenant.service'
import { TenantType } from './tenant.types'
import { errorToMessage } from 'utility/service-errors'

export function* startTenantFetch() {
  try {
    yield put(tenantActions.fetchTenant())
    const result: TenantType = yield call(tenantService.fetchTenant)
    yield put(tenantActions.fetchTenantSuccess(result))
  } catch (e: any) {
    yield put(
      tenantActions.fetchTenantFailed(errorToMessage(e, 'tenant.fetch'))
    )
  }
}
